import {Pageable, Prognosis, Response} from "@core/model";
import {ApiBuilder} from "..";

type PrognosisParams = {
  assetId?: string;
  from?: number;
  to?: number;
  page?: number;
  size?: number;
};

// Prognosi per asset specifico o tutti gli assets con range temporale
const fetchPrognosis = (builder: ApiBuilder) =>
  builder.query<Pageable<Prognosis>, PrognosisParams>({
    query: params => {
      const queryParams = new URLSearchParams();
      if (params.assetId) {
        queryParams.append("assetId", params.assetId.toString());
      }
      if (params.from) {
        queryParams.append("from", params.from.toString());
      }
      if (params.to) {
        queryParams.append("to", params.to.toString());
      }
      if (params.page !== undefined) {
        queryParams.append("page", params.page.toString());
      }
      if (params.size !== undefined) {
        queryParams.append("size", params.size.toString());
      }

      return {
        url: `/api/prognosis/range${queryParams.toString() ? `?${queryParams.toString()}` : ""}`,
        method: "GET",
      };
    },
    transformResponse: (response: Response<Pageable<Prognosis>>) => {
      return response.data;
    },
    providesTags: result =>
      result?.content
        ? [
            ...result.content.map((p: Prognosis) => ({
              type: "prognosis" as const,
              id: p.assetId,
            })),
            {type: "prognosis", id: "LIST"},
          ]
        : [{type: "prognosis", id: "LIST"}],
  });

// Prognosi più recente per asset specifico o tutti gli assets
const fetchPrognosisLatest = (builder: ApiBuilder) =>
  builder.query<Prognosis[], {assetId?: number}>({
    query: params => {
      const queryParams = new URLSearchParams();
      if (params.assetId) {
        queryParams.append("assetId", params.assetId.toString());
      }

      return {
        url: `/api/prognosis/latest${queryParams.toString() ? `?${queryParams.toString()}` : ""}`,
        method: "GET",
      };
    },
    transformResponse: (response: Response<Prognosis[]>) => {
      return response.data;
    },
    providesTags: result =>
      result
        ? [
            ...result.map(p => ({type: "prognosis" as const, id: p.assetId})),
            {type: "prognosis", id: "LATEST"},
          ]
        : [{type: "prognosis", id: "LATEST"}],
  });

export {fetchPrognosis, fetchPrognosisLatest};
